import { render, staticRenderFns } from "./moreRefData.vue?vue&type=template&id=21b736c6"
import script from "./moreRefData.vue?vue&type=script&lang=js"
export * from "./moreRefData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports